import { Component, Input, OnInit, OnDestroy } from "@angular/core"
import { FormGroup, FormControl } from "@angular/forms"
import { FormFieldBase } from "../form-field/form-field-base"
import { Subject } from "rxjs"
import { takeUntil } from "rxjs/operators"
@Component({
  selector: "app-lead-df-field",
  templateUrl: "lead-df-field.component.html",
  styleUrls: ["lead-df-field.component.scss"],
})
export class LeadDfFieldComponent {
  @Input() question: FormFieldBase<any>
  @Input() form: FormGroup

  public ngSelectSelectedValues: string[] = []
  private destroy$ = new Subject<void>()

  constructor() {}

  ngOnInit() {
    if (this.question.controlType === "dropdown-multiple") {
      const formControl = this.form.get(this.question.key) as FormControl

      if (
        formControl &&
        typeof formControl.value === "string" &&
        formControl.value.length > 0
      ) {
        this.ngSelectSelectedValues = formControl.value
          .split(",")
          .map(v => v.trim())
          .filter(v => v !== "")
      } else {
        this.ngSelectSelectedValues = []
      }

      if (formControl) {
        formControl.valueChanges
          .pipe(takeUntil(this.destroy$))
          .subscribe(value => {
            if (typeof value === "string") {
              this.ngSelectSelectedValues = value
                .split(",")
                .map(v => v.trim())
                .filter(v => v !== "")
            } else {
              this.ngSelectSelectedValues = []
            }
          })
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  get isValid() {
    return this.form.controls[this.question.key].valid
  }

  isChecked(values: string | string[], checkValue: string): boolean {
    if (!values) return false

    // Only handle array logic for multicheckbox
    if (this.question.controlType === "multicheckbox") {
      if (typeof values === "string") {
        const valueArray = values
          .split(/,|\n/)
          .map(v => v.trim())
          .filter(v => v !== "")
        return valueArray.includes(checkValue)
      }

      if (Array.isArray(values)) {
        return values.includes(checkValue)
      }
    }

    // Original logic for other types
    return values === checkValue
  }

  onCheckboxChange(event: any, key: string, value: string) {
    const formControl = this.form.get(key)
    let currentValue = formControl.value || []

    // Convert to array if it's a string
    if (typeof currentValue === "string") {
      currentValue = currentValue.split(",").filter(v => v)
    }

    if (event.target.checked) {
      if (!currentValue.includes(value)) {
        currentValue.push(value)
      }
    } else {
      const index = currentValue.indexOf(value)
      if (index > -1) {
        currentValue.splice(index, 1)
      }
    }

    formControl.setValue(currentValue)
    // console.log(`Checkbox ${key} changed:`, currentValue)
  }

  onNgSelectChange(selectedItems: string[], key: string) {
    let valuesToJoin: string[];
    if (selectedItems && selectedItems.length > 0 && typeof selectedItems[0] === 'object' && selectedItems[0] !== null) {
      valuesToJoin = (selectedItems as any[]).map(item => item.key);
    } else {
      valuesToJoin = selectedItems;
    }
    const formControl = this.form.get(key) as FormControl;
    // Join the array of selected keys back into a comma-separated string
    const stringValue = valuesToJoin ? valuesToJoin.join(',') : '';
    formControl.setValue(stringValue);
    // console.log(`ng-select ${key} changed:`, stringValue);
  }
}
